import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import * as React from 'react';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import Typography from './HomeTypography';
import { MilestoneItem } from './MilestoneItem';

export const CurrentEventMilestones = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const currentEvent = currentEventData?.currentEvent ?? null;

  if (currentEvent === null) {
    return null;
  }

  return (
    <Box
      component="section"
      sx={(theme) => ({
        display: 'flex',
        bgcolor: theme.palette.primary.contrastText,
        overflow: 'hidden',
      })}
    >
      <Container
        sx={{
          mt: 10,
          mb: 15,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/home/background-curves.png"
          alt="curvy lines"
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            top: -180,
            opacity: 0.7,
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{ mb: 14 }}
          fontWeight="medium"
        >
          Paliers
        </Typography>
        <div>
          {currentEvent.milestones.length > 0 ? (
            <Grid container spacing={5}>
              {currentEvent.milestones.map((milestone) => (
                <MilestoneItem key={milestone.id} milestone={milestone} />
              ))}
            </Grid>
          ) : (
            <Typography variant="subtitle1">
              Aucun palier pour le moment. Revenez plus tard !
            </Typography>
          )}
        </div>
      </Container>
    </Box>
  );
};
